import React, { useEffect, useRef, useState } from 'react';

import Banner from 'components/shared/Banner/Banner';

import { WIZARD_PROGRESS } from '../../lib/enum';
import AcknowledgementFooter from '../AcknowledgementFooter';

import MediPayTermsSection from './components/MediPayTermsSection';
import MyriadHealthTermsSection from './components/MyriadHealthTermsSection';

const COMPLETED_STATUSES = [WIZARD_PROGRESS.COMPLETED, WIZARD_PROGRESS.CONFIRMED];

const GO_LIVE_SUBSTEP_CODE = 'onboarding__go_live_dates_and_trainings__go_live_dates_and_trainings';

const TermsAndConditions = ({
  isAdmin,
  addFooterActions,
  setHeaderButtonProps,
  onNext,
  mutateOrchestratorData,
  orchestratorData,
  wizardState,
  navigateToSubstep
}) => {
  const isCompleted = COMPLETED_STATUSES.includes(orchestratorData?.handlerStatus);
  const [mediPayAccepted, setMediPayAccepted] = useState(false);
  const [myriadHealthAccepted, setMyriadHealthAccepted] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  const scrollContainerRef = useRef(null);

  const isGoLiveDateMissing = !wizardState?.instance?.hard_go_live_date;
  const allAccepted = mediPayAccepted && myriadHealthAccepted;

  useEffect(() => {
    setHeaderButtonProps(null);
    addFooterActions([
      {
        text: isAdmin || isCompleted ? 'Continue' : 'Accept & Continue',
        onClick:
          isAdmin || isCompleted ? onNext : () => mutateOrchestratorData({ acknowledge: true }),
        isDisabled: !isAdmin && !isCompleted && (!allAccepted || isGoLiveDateMissing)
      }
    ]);
  }, [
    allAccepted,
    isCompleted,
    isGoLiveDateMissing,
    addFooterActions,
    setHeaderButtonProps,
    onNext,
    mutateOrchestratorData
  ]);

  const bannerContent =
    isGoLiveDateMissing && showBanner ? (
      <Banner
        icon="info-circle-filled"
        color="danger"
        variant="lighter"
        title={null}
        className="[@media(max-width:1200px)]:gap-1 [@media(max-width:1200px)]:rounded-none [@media(max-width:1200px)]:py-3 [@media(max-width:1200px)]:[&>div:first-child>button]:!ml-0 [@media(max-width:1200px)]:[&>div:first-child>button]:!w-full [@media(max-width:1200px)]:[&>div:first-child>button]:!basis-full [@media(max-width:1200px)]:[&>div:first-child]:!flex-wrap [@media(max-width:1200px)]:[&>div:first-child]:!items-center [@media(max-width:1200px)]:[&>div:first-child]:!justify-start"
        message="You must confirm your Go-live dates before acknowledging Terms & conditions."
        button={{
          text: 'Go to Go-live dates step',
          onClick: () => navigateToSubstep(GO_LIVE_SUBSTEP_CODE)
        }}
        handleClose={() => setShowBanner(false)}
      />
    ) : null;

  return (
    <div ref={scrollContainerRef} className="flex h-full flex-col">
      <div className="flex flex-col gap-4 pb-4 pt-4">
        <MediPayTermsSection
          isAdmin={isAdmin}
          isCompleted={isCompleted}
          mediPayAccepted={mediPayAccepted}
          setMediPayAccepted={setMediPayAccepted}
        />

        <MyriadHealthTermsSection
          isAdmin={isAdmin}
          isCompleted={isCompleted}
          myriadHealthAccepted={myriadHealthAccepted}
          setMyriadHealthAccepted={setMyriadHealthAccepted}
        />
      </div>
      <AcknowledgementFooter
        scrollContainerRef={scrollContainerRef}
        banner={bannerContent}
        text=""
        isChecked={false}
        onChange={() => {}}
        isDisabled
        className="border-t-0 [&>div:first-child]:hidden"
      />
    </div>
  );
};

export default TermsAndConditions;
